import Plan, { PlanName } from './Plan';

interface IAppliedCoupon {
  code: string;
  allowed_plans: PlanName[];
  default_for_signup?: boolean;
  dollar_off: number;
  free_shipping: boolean;
  max_amount: number;
  max_order_count: number;
  minimum_base_price: string;
  percentage_off: number;
  status: string;
  extras_only: boolean;
}

class AppliedCoupon implements IAppliedCoupon {
  code: string;
  allowed_plans: PlanName[];
  default_for_signup?: boolean;
  dollar_off: number;
  free_shipping: boolean;
  max_amount: number;
  max_order_count: number;
  minimum_base_price: string;
  percentage_off: number;
  status: string;
  extras_only: boolean;

  constructor(attributes: IAppliedCoupon) {
    Object.assign(this, attributes);
  }

  get discountType(): string {
    return this.percentage_off > 0 ? 'percentage_off' : 'dollar_off';
  }

  isValidForPlan(planName: PlanName): boolean {
    return this.allowed_plans.includes(planName);
  }

  isValidForSignup(plan: Plan): boolean {
    const meetsMinimumBasePrice = this.minimum_base_price
      ? plan.subtotalPrice >= Number(this.minimum_base_price) : true;
    const meetsExtrasRequirement = this.extras_only ? !!plan.extras : true;

    if (!meetsMinimumBasePrice || !meetsExtrasRequirement) {
      return false;
    }

    return this.isValidForPlan(plan.name);
  }

  calculateDiscount(plan: Plan): number {
    let discountAmount = 0;
    if (!this.isValidForSignup(plan)) {
      return discountAmount;
    }

    if (this.percentage_off) {
      discountAmount = Math.min(
        plan.subtotalPrice * (this.percentage_off / 100), Number(this.max_amount),
      );
    } else {
      discountAmount = Math.min(plan.subtotalPrice, this.dollar_off);
    }

    return discountAmount;
  }
}

export type { IAppliedCoupon };
export default AppliedCoupon;
